export const EEPP_TABLE_COLUMNS = [
  { field: 'fecha_alta_ap', align: 'left', width: 140, type: 'date' },
  {
    field: 'nombre',
    align: 'left',
    cellStyle: {
      textTransform: 'capitalize',
    },
  },
  {
    field: 'cif',
    align: 'left',
    width: 120,
    cellStyle: {
      textTransform: 'uppercase',
    },
  },
  { field: 'telefono', align: 'left', width: 120 },
  { field: 'email', align: 'left' },
  { field: 'cnae_id', align: 'left', width: 180, comboId: 'cnae' },
  { field: 'comunidad_nombre', align: 'left' },
  { field: 'num_instaladores_colaboradores', align: 'left', width: 60 },
]

export const EEPP_TABLE_FILTERS = [
  {
    name: 'comunidad_autonoma',
    comboId: 'cod_zona_zeus',
    size: 'small',
    multiple: true,
  },
  {
    name: 'cnae_id',
    comboId: 'cnae',
    multiple: true,
  },


  {
    name: 'fecha_alta_desde',
    filterType: 'date',
    maxDateField: 'fecha_alta_hasta',
  },
  {
    name: 'fecha_alta_hasta',
    filterType: 'date',
    minDateField: 'fecha_alta_desde',
  },
  {
    name: 'instaladores',
    filterType: 'switch',
    cleanSelf: false,
  },

]